import { observer } from 'mobx-react-lite';
import { CalendarItemPeekCallout } from 'owa-calendar-peek-callout';
import * as React from 'react';
import type { Target } from '@fluentui/react/lib/Callout';
import { BoardCalendarAssetEntrySource } from '../constants';
import { useCalendarEventsPeekCalloutState } from '../hooks/useCalendarEventsPeekCalloutState';
import { useRepositionableCallout } from 'owa-react-hooks/lib/useRepositionableCallout';
import EventScope from 'owa-service/lib/contract/EventScope';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { launchCalendarFullCompose } from 'owa-calendar-forms-launch-handlers';
import type { FullComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';

/**
 * Props for item peek renderer
 */
export interface CalendarEventPeekCalloutProps {
    target: Target | undefined;
    onDismissed: () => void;
}

/**
 * Component for rendering item peek
 */
export default observer(function CalendarEventPeekCallout(props: CalendarEventPeekCalloutProps) {
    const { onDismissed, target } = props;

    const {
        onOpenEventClicked,
        onReviewProposedNewTimeClicked,
    } = useCalendarEventsPeekCalloutState(props);

    const {
        onMouseDown,
        onPositioned,
        calloutStyles,
        manuallyRepositioned,
    } = useRepositionableCallout();

    if (!target) {
        return null;
    }

    return (
        <CalendarItemPeekCallout
            target={target}
            onOpenEventClicked={onOpenEventClicked}
            onLaunchFullCompose={onLaunchFullCompose}
            onReviewProposedNewTimeClicked={onReviewProposedNewTimeClicked}
            viewType={BoardCalendarAssetEntrySource}
            entrySource={'BoardCalendarAsset'}
            onDismissed={onDismissed}
            onPositioned={onPositioned}
            styles={calloutStyles}
            onMouseDown={onMouseDown}
            beakWidth={manuallyRepositioned ? 0 : undefined} // if repositioned manually, hide the beak
        />
    );
});

function onLaunchFullCompose(
    entrySource: string,
    eventScope: EventScope,
    eventUpdates: Partial<CalendarEvent>,
    itemHasUpdates?: boolean
) {
    launchCalendarFullCompose({
        fullComposeEntrySource: entrySource as FullComposeEntrySourceType,
        eventScope: eventScope,
        eventUpdates: eventUpdates,
        itemHasUpdates: itemHasUpdates,
    });
}
